<template>
  <b-modal
    title="Inserimento voto"
    class="modal-info registro"
    v-model="show1"
    ok-variant="danger"
    :ok-only="true"
    size="xl"
  >
    <div class="registro">
      Voto - Data
      <br />
      <input type="text" class="voto2" v-model="voto" />
      &nbsp;
      <datetime class="datavoto2" v-model="data" :max-datetime="adesso" :min-datetime="mindata()" @close="checkmsg()" :disabled="oldvoto"/>
      <br />
      <br />Oggetto:
      <input type="text" class="votooggetto" v-model="oggetto" style="width: 100%;" />
    </div>
    <hr />
    <table v-if="skills">
      <tr>
        <th colspan="2" rowspan="4" valign="top">SKILLS</th>
        <th colspan="4">LIVELLO di acquisizione</th>
      </tr>
      <tr>
        <th width="10%" class="punti1"></th>
        <th width="10%" class="punti2"></th>
        <th width="10%" class="punti3"></th>
        <th width="10%" class="punti4"></th>
      </tr>
      <tr>
        <th class="punti">Non è in grado di svolgere il compito</th>
        <th class="punti">Svolge compiti semplici applicando regole e procedure di base</th>
        <th
          class="punti"
        >Svolge compiti e risolve problemi complessi in situazioni note utilizzando le conoscenze e le abilità acquisite</th>
        <th
          class="punti"
        >Svolge compiti e risolve problemi complessi in situazione anche non note mostrando padronanza nell’uso delle conoscenze e delle abilità.</th>
      </tr>
      <tr>
        <th class="punti1">NULLO</th>
        <th class="punti2">BASE</th>
        <th class="punti3">INTERMEDIO</th>
        <th class="punti4">AVANZATO</th>
      </tr>
      <tr>
        <td width="15%">Autonomia</td>
        <td width="45%">Svolge i compiti assegnati senza bisogno di supervisione</td>
        <td class="punti">
          <input type="radio" v-model="data1" name="r1" value="1">
        </td>
        <td class="punti">
          <input type="radio" v-model="data1" name="r1" value="2">
        </td>
        <td class="punti">
          <input type="radio" v-model="data1" name="r1" value="3">
        </td>
        <td class="punti">
          <input type="radio" v-model="data1" name="r1" value="4">
        </td>
      </tr>
      <tr>
        <td>Organizzazione</td>
        <td>Identifica obiettivi e priorità e pianifica il processo tenendo conto del tempo a disposizione</td>
        <td class="punti">
          <input type="radio" v-model="data2" name="r2" value="1">
        </td>
        <td class="punti">
          <input type="radio" v-model="data2" name="r2" value="2">
        </td>
        <td class="punti">
          <input type="radio" v-model="data2" name="r2" value="3">
        </td>
        <td class="punti">
          <input type="radio" v-model="data2" name="r2" value="4">
        </td>
      </tr>
      <tr>
        <td>Precisione</td>
        <td>È accurato ed attento a ciò che fa e ne cura i dettagli</td>
        <td class="punti">
          <input type="radio" v-model="data3" name="r3" value="1">
        </td>
        <td class="punti">
          <input type="radio" v-model="data3" name="r3" value="2">
        </td>
        <td class="punti">
          <input type="radio" v-model="data3" name="r3" value="3">
        </td>
        <td class="punti">
          <input type="radio" v-model="data3" name="r3" value="4">
        </td>
      </tr>
      <tr>
        <td>Apprendimento</td>
        <td>Riconosce lacune ed aree di miglioramento e si attiva per migliorare</td>
        <td class="punti">
          <input type="radio" v-model="data4" name="r4" value="1">
        </td>
        <td class="punti">
          <input type="radio" v-model="data4" name="r4" value="2">
        </td>
        <td class="punti">
          <input type="radio" v-model="data4" name="r4" value="3">
        </td>
        <td class="punti">
          <input type="radio" v-model="data4" name="r4" value="4">
        </td>
      </tr>
      <tr>
        <td>Comunicazione</td>
        <td>Ascolta e in modo chiaro e sintetico trasmette informazioni e condivide idee con vari interlocutori</td>
        <td class="punti">
          <input type="radio" v-model="data5" name="r5" value="1">
        </td>
        <td class="punti">
          <input type="radio" v-model="data5" name="r5" value="2">
        </td>
        <td class="punti">
          <input type="radio" v-model="data5" name="r5" value="3">
        </td>
        <td class="punti">
          <input type="radio" v-model="data5" name="r5" value="4">
        </td>
      </tr>
      <tr>
        <td>Problem Solving</td>
        <td>Identifica priorità e criticità e individua le possibili migliori soluzioni ai problemi</td>
        <td class="punti">
          <input type="radio" v-model="data6" name="r6" value="1">
        </td>
        <td class="punti">
          <input type="radio" v-model="data6" name="r6" value="2">
        </td>
        <td class="punti">
          <input type="radio" v-model="data6" name="r6" value="3">
        </td>
        <td class="punti">
          <input type="radio" v-model="data6" name="r6" value="4">
        </td>
      </tr>
      <tr>
        <td>Team work</td>
        <td>Lavora e collabora positivamente con gli altri per eseguire il compito assegnato</td>
        <td class="punti">
          <input type="radio" v-model="data7" name="r7" value="1">
        </td>
        <td class="punti">
          <input type="radio" v-model="data7" name="r7" value="2">
        </td>
        <td class="punti">
          <input type="radio" v-model="data7" name="r7" value="3">
        </td>
        <td class="punti">
          <input type="radio" v-model="data7" name="r7" value="4">
        </td>
      </tr>
      <tr>
        <td>Leadership</td>
        <td>Conduce, motiva e trascina gli altri verso l'obiettivo definito</td>
        <td class="punti">
          <input type="radio" v-model="data8" name="r8" value="1">
        </td>
        <td class="punti">
          <input type="radio" v-model="data8" name="r8" value="2">
        </td>
        <td class="punti">
          <input type="radio" v-model="data8" name="r8" value="3">
        </td>
        <td class="punti">
          <input type="radio" v-model="data8" name="r8" value="4">
        </td>
      </tr>
    </table>
    <div slot="modal-footer" style="width: 100%;">
      <div style="float: left;">
        <button type="button" class="btn btn-danger" @click="show1=false">Annulla</button>
      </div>
      <div style="float: right;margin-left: 10px;">
        <button
          type="button"
          class="btn btn-info"
          @click="addvoto(false)"
          :disabled="!validvoto"
          title="Salva"
          v-if="!readonly && (!oldvoto || !hm)"
        >
          Salva
          <i class="fa fa-check"></i>
        </button>
      </div>
      <div style="float: right;margin-left: 10px;">
        <button
          type="button"
          class="btn btn-info"
          @click="addvoto(true)"
          :disabled="!validvotohome"
          title="Salva HOMEWORK"
          v-if="!readonly && (!oldvoto || hm) && dwhat.mid!=999999"
        >
          Salva
          <i class="fa fa-home"></i>
        </button>
      </div>
      <div style="clear: both;"></div>
    </div>
  </b-modal>
</template>
<script>
import { DateTime } from "luxon";
import { API } from "@/api.js";

export default {
  name: "InsVoto",
  mixins: [window.myMixin],
  components: {},
  data: function() {
    return {
      show1: false,
      readonly: false,
      oldvoto: false,
      dwtempl: {
        // serve solo per definire l'oggetto
        voto: "",
        data: "",
        oggetto: "",
        data1: 0,
        data2: 0,
        data3: 0,
        data4: 0,
        data5: 0,
        data6: 0,
        data7: 0,
        data8: 0
      },
      dwhat: {
        voto: "",
        data: "",
        oggetto: "",
        data1: 0,
        data2: 0,
        data3: 0,
        data4: 0,
        data5: 0,
        data6: 0,
        data7: 0,
        data8: 0
      },
      voto: "",
      data: "",
      oggetto: "",
      data1: 0,
      data2: 0,
      data3: 0,
      data4: 0,
      data5: 0,
      data6: 0,
      data7: 0,
      data8: 0,
      // in base al valore vedo se rimostrare l'ultimo oggetto salvato
      lastOggetto: '',
      lastOggettoData: null,
      lastOggettoModulo: null,
      currMod: null,
    };
  },
  props: ["show", "value","skills"],
  mounted: async function() {
    console.log("INSVOTO mounted !!")
  },
  watch: {
    show: function(newVal, oldVal) {
      // watch it
      // console.log("Prop show changed: ", newVal, " | was: ", oldVal);
      this.show1 = newVal;
    },
    data: function(newVal, oldVal) {
      console.log("DATA changed!: ", newVal, " | was: ", oldVal,"?:",this.oggetto);
      if(this.lastOggettoData==newVal && this.currMod==this.lastOggettoModulo && !this.oldvoto)
        this.oggetto = this.lastOggetto
      else {
        // console.log("azzero oggetto")
        // this.oggetto = ''
      }
    },
    show1: function(newVal, oldVal) {
      // watch it
      // console.log("Prop show1 changed: ", newVal, " | was: ", oldVal);
      if (!newVal) {
        this.setdwhat();
        this.dwhat.cancel = true;
        this.$emit("input", this.dwhat); // questo emit si aggancia come v-model
      }
    },
    value: function(newVal, oldVal) {
      // watch it
      console.log("Prop value changed: ", newVal, " | was: ", oldVal);
      this.currMod = newVal.mid
      
      // console.log("!!!",newVal.ro)
      this.readonly = newVal.ro
      this.oldvoto = newVal.oldvoto || false
      this.hm = newVal.hm || false
      this.dwhat = Object.assign({}, newVal);
      this.getdwhat();
    }
  },
  computed: {
    adesso: function() {
      return DateTime.local().plus({ days: 0 }).toISODate() + "T00:00:00Z"
    },
    validvoto: function() {
      var ok = !this.skills || this.data1 && this.data2 && this.data3 && this.data4 && this.data5 && this.data6 && this.data7 && this.data8
      // console.log("validvoto")
      return this.data && this.voto != "" && this.oggetto && this.oggetto != "" && ok;
    },
    validvotohome: function() {
      return this.data && this.voto != "" && this.oggetto && this.oggetto != "";
    }
  },
  methods: {
    mindata: function(){
      // la routine si mangia un giorno, uno lo aggiungo e uno per abbondare
      let ret
      if(window.FORMVOTIALUNNI_PRIMOSEMESTRE==1) {
        ret = DateTime.fromISO(window.FORMVOTIALUNNI_dpickerannomin + '-09-01T00:00:00Z').toISODate()+'T00:00:00Z'
      } else {
        ret =  DateTime.fromISO(window.FORMVOTIALUNNI_DATAFINESEM+'T00:00:00Z').plus({ days: 2 }).toISODate()+'T00:00:00Z'
      }
      return ret
    },
    setdwhat() {
      Object.keys(this.dwtempl).forEach(k => (this.dwhat[k] = this[k]));
    },
    getdwhat() {
      Object.keys(this.dwtempl).forEach(k => (this[k] = this.dwhat[k]));
      console.log("DATA:",this.data)
      if(this.data)
        this.data = this.data + "T00:00:00Z"
      else
        this.data = DateTime.local().toISODate() + "T00:00:00Z"
      console.log("DATA2:",this.data)
    },
    async checkmsg() {
      if (!this.data) return;
      var mid = this.dwhat.mid;
      var d = this.data.split("T")[0];
      var ret = await API.sqlprep(this, "insvoto.selpdescr",[mid,d]);
      if (ret.data.dati.length > 0) {
        this.oggetto = JSON.parse(ret.data.dati[0].descrizione).default;
      }
    },
    async addvoto(hm) {
      console.log("EMIT...");
      this.setdwhat();
      this.dwhat.hm = hm;
      this.dwhat.cancel = false;
      if(this.dwhat.oldvoto) 
        this.dwhat.update = true
      this.$emit("input", this.dwhat); // questo emit si aggancia come v-model
      this.lastOggettoData = this.data
      this.lastOggetto = this.oggetto
      this.lastOggettoModulo = this.currMod
    }
  }
};
</script>
<style scoped>
th.punti {
  font-size: x-small;
  text-align: center;
  vertical-align: middle;
}
td.punti {
  text-align: center;
}
th.punti1 {
  text-align: center;
  vertical-align: top;
  color: red;
}
th.punti2 {
  text-align: center;
  vertical-align: top;
  color: orange;
}
th.punti3 {
  text-align: center;
  vertical-align: top;
  color: green;
}
th.punti4 {
  text-align: center;
  vertical-align: top;
  color: lightseagreen;
}
.voto2 {
  font-size: x-large;
  width: 60px;
  text-align: right;
  background-color: lightgreen;
  display: inline-block;
  border-style: ridge;
}
.datavoto2 {
  font-size: x-large;
  width: 200px;
  display: inline-block;
  border-style: ridge;
  text-align: center;
}
.fa-check,
fa-home {
  color: green;
}
</style>